/**
 * Javascript-Equal-Height-Responsive-Rows
 * https://github.com/Sam152/Javascript-Equal-Height-Responsive-Rows
 */
/**
 * @EDIT by SETU (ga)
 *
 * we have make any changes and using another plugin in this plugin
 * jquery-actual. And removed it again, because it is super slow.
 *
 * All edited pasts have comments to see the different from origin
 */
export const grid = () => {
    'use strict';

    /**
     * EDIT: This is editing by SETU (ga)
     * We set a new rule if class 'at-heighest-col' set on row
     * and make another function
     */
    var fixHeightClass = 'at-heighest-col';
    $.fn.fixHeight = function () {
        var fix = [];
        $.each(this, function (i, element) {
            var $element = $(element);
            if ($element.hasClass(fixHeightClass)) {
                // Should we include the elements padding in it's height?
                var includePadding = ($element.css('box-sizing') === 'border-box') || ($element.css('-moz-box-sizing') === 'border-box');
                if (includePadding) {
                    fix = element.firstElementChild.getElementsByClassName('carousel-inner')[0].getBoundingClientRect('height');
                } else {
                    fix = element.firstElementChild.getElementsByClassName('carousel-inner')[0].clientHeight;
                }
            }
        });
        this.each((index, item) => {
            item.style.height = fix.height + 'px';
        });
        return this;
    }

    const gridHeight = ($tiles, columns) => {
        for (let i = 0; i < $tiles.length; i++) {
            if (i % columns === 0) {
                let row = $($tiles[i]);
                for (let n = 1; n < columns; n++) {
                    row = row.add($tiles[i + n]);
                }
                /**
                 * EDIT: This is editing by SETU (ga)
                 * We set a new rule if class 'at-heighest-col' set on row
                 * and make another function
                 */
                if ($($tiles).hasClass(fixHeightClass)) {
                    row.fixHeight();
                }
            }
        }
    }

    /**
     * Create a grid of equal height elements.
     */
    $.fn.equalHeightGrid = function (columns) {
        const $tiles = this.filter(':visible');
        gridHeight($tiles, columns);
        return this;
    };


    /**
     * Create a grid of equal height elements.
     * @ADDED by SETU (ga)
     *
     * this is the same as above - with a new functionallity
     * to use all visible and invisible element
     */
    $.fn.equalHeightGridAll = function (columns) {
        const $tiles = this;
        gridHeight($tiles, columns);
        return this;
    };

    /**
     * Detect how many columns there are in a given layout.
     */
    $.fn.detectGridColumns = function () {
        let offset = 0,
            cols = 0;
        const $tiles = this.filter(':visible');
        $tiles.each(function (i, elem) {
            const elemOffset = $(elem).offset().top;
            if (offset === 0 || elemOffset === offset) {
                cols++;
                offset = elemOffset;
            } else {
                return false;
            }
        });
        return cols;
    };

    /**
     * Ensure equal heights now, on ready, load and resize.
     */
    var grids_event_uid = 0;
    $.fn.responsiveEqualHeightGrid = function (allElements) {
        allElements = allElements || false;
        const _this = this;
        const event_namespace = '.grids_' + grids_event_uid;
        _this.data('grids-event-namespace', event_namespace);

        function syncHeights() {
            const cols = _this.detectGridColumns();
            if (allElements) {
                _this.equalHeightGridAll(cols);
            } else {
                _this.equalHeightGrid(cols);
            }
        }

        $(window).bind('resize' + event_namespace + ' load' + event_namespace, syncHeights);

        syncHeights();
        grids_event_uid++;
        return this;
    };

    /**
     * Unbind created events for a set of elements.
     */
    $.fn.responsiveEqualHeightGridDestroy = function () {
        const _this = this;
        _this.each((index, item) => {
            item.style.height = 'auto';
        });
        // @EDIT by setu (ga) look if data is empty
        if (!!_this.data('grids-event-namespace')) {
            $(window).unbind(_this.data('grids-event-namespace'));
        }
        return this;
    };

}
grid();
